import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { DOCUMENTS_REVIEW } from 'constants/controllers'

export default new Controller({
  name: 'LegacyDocumentsReviewRedirect',
  route: ':aol/docreview/:category/:sectionId/:precedentIds',
  controller (Router, { params, query }) {
    const target = url(DOCUMENTS_REVIEW, { ...params, documentIds: params.precedentIds }, query)
    replaceUrl(target)
  }
})
